// hooks/useNotificationScheduler.js
import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import NotificationScheduler from '../services/NotificationScheduler';

/**
 * Hook pour démarrer automatiquement le NotificationScheduler
 * uniquement pour les utilisateurs administrateurs
 */
export const useNotificationScheduler = () => {
  const { user } = useAuth();
  const schedulerStartedRef = useRef(false);

  useEffect(() => {
    // Démarrer le scheduler seulement si :
    // 1. L'utilisateur est connecté
    // 2. L'utilisateur est admin/super_admin/project_manager
    // 3. Le scheduler n'est pas déjà démarré
    const shouldStartScheduler = 
      user && 
      (user.role === 'admin' || user.role === 'super_admin' || user.role === 'project_manager') &&
      !schedulerStartedRef.current;

    if (shouldStartScheduler) {
      console.log('🚀 SCHEDULER-HOOK: Démarrage du NotificationScheduler pour', user.email);
      
      try {
        NotificationScheduler.start();
        schedulerStartedRef.current = true;
        
        // Effectuer une vérification initiale après 5 secondes
        setTimeout(() => {
          NotificationScheduler.forceTimelineDelayCheck();
        }, 5000);
        
      } catch (error) {
        console.error('❌ SCHEDULER-HOOK: Erreur démarrage scheduler:', error);
      }
    }

    // Cleanup : arrêter le scheduler quand l'utilisateur se déconnecte
    return () => {
      if (schedulerStartedRef.current && (!user || !['admin', 'super_admin', 'project_manager'].includes(user.role))) {
        console.log('🛑 SCHEDULER-HOOK: Arrêt du NotificationScheduler');
        NotificationScheduler.stop();
        schedulerStartedRef.current = false;
      }
    };

  }, [user?.role, user?.email]);

  // Exposer des méthodes utiles
  const forceCheck = async () => {
    if (schedulerStartedRef.current) {
      await NotificationScheduler.forceTimelineDelayCheck();
    }
  };

  const getStatistics = async () => {
    if (schedulerStartedRef.current) {
      return await NotificationScheduler.getDelayStatistics();
    }
    return null;
  };

  const checkDossierAfterUpdate = async (dossierId) => {
    if (schedulerStartedRef.current && dossierId) {
      await NotificationScheduler.checkDossierAfterTimelineUpdate(dossierId);
    }
  };

  return {
    isRunning: schedulerStartedRef.current,
    forceCheck,
    getStatistics,
    checkDossierAfterUpdate
  };
};